// Matches youtu.be/ID, youtube.com/watch?v=ID, /embed/ID, /shorts/ID, /live/ID
const YOUTUBE_REGEX = /(?:youtu\.be\/|youtube(?:-nocookie)?\.com\/(?:watch\?(?:.*&)?v=|embed\/|shorts\/|live\/))([a-zA-Z0-9_-]{11})/;

interface YoutubeUrlsResult {
  link: string;
  thumbnailSmall: string;
  thumbnailLarge: string;
  embedUrl: string;
  videoId: string;
}

/**
 * Generates YouTube URLs and metadata for a given video URL.
 * Supports youtu.be, youtube.com/watch, /embed/, /shorts/, and /live/ formats.
 * @returns Object with video link, thumbnails, embed URL, and video ID, or null if not a valid YouTube URL.
 */
export function getYoutubeUrls(videoUrl: string): YoutubeUrlsResult | null {
  const match = videoUrl.trim().match(YOUTUBE_REGEX);
  const videoId = match?.[1];
  if (!videoId) {
    return null;
  }

  return {
    link: `https://www.youtube.com/watch?v=${videoId}`,
    thumbnailSmall: `https://i3.ytimg.com/vi/${videoId}/hqdefault.jpg`,
    thumbnailLarge: `https://i3.ytimg.com/vi/${videoId}/maxresdefault.jpg`,
    embedUrl: `https://www.youtube.com/embed/${videoId}?enablejsapi=1`,
    videoId
  };
}
